var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-alert',{staticClass:"gl-rounded-none",attrs:{"variant":"danger","dismissible":false}},[_vm._v("\n  "+_vm._s(_vm.$options.i18n.bannerMessage)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }